import type { Event } from '../types';

type Payload = { event_type: 'ElementClicked' };

export class ElementClickedEvent implements Event<Payload> {
  readonly payload: Payload = { event_type: 'ElementClicked' };
  readonly eventCategory = 'Element';
  readonly eventName = 'Clicked';
  readonly rumActionName = 'ElementClicked';
}
